module.exports = __webpack_public_path__ + "img/about_con_2-1.ed78e124.png";